import {useRef} from "react";
import domtoimage from "dom-to-image-more";

import {saveAs} from "file-saver";

export function useDownloadMapAsPng() {
    const mapObjectRef = useRef(null);
    const mapDomRef = useRef(null);

    const setConfig = (mapObject, mapDomElement) => {
        mapObjectRef.current = mapObject;
        mapDomRef.current = mapDomElement;
    };

    const getDimensions = () => {
        return mapObjectRef.current.getSize();
    };

    const generate = async () => {
        var dimensions = getDimensions();

        const dataUrl = await domtoimage.toBlob(mapDomRef.current, {
            width: dimensions.x,
            height: dimensions.y,
        });
        return dataUrl;
    };

    const download = async callback => {
        const blob = await generate();
        saveAs(blob, "map.png");

        if (callback) {
            callback();
        }
    };

    return {setConfig, download, generate, getDimensions};
}
